import styled from 'styled-components';

import { LANGUAGE_LABELS } from 'src/vars';

const LANGUAGE_OPTIONS = [
    { value: '', label: 'Browser language' },
    ...Object.entries(LANGUAGE_LABELS).map(([language, label]) => ({
        value: language,
        label: `${label} (${language})`,
    })),
];

const LanguageControl = styled.label`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--text-secondary);
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
`;

const LanguageSelect = styled.select`
    min-width: 132px;
    padding: 5px 28px 5px 8px;
    border: 1px solid var(--border-faint);
    border-radius: 4px;
    background: var(--surface);
    color: var(--text-primary);
    font: inherit;
    cursor: pointer;

    &:hover,
    &:focus-visible {
        border-color: var(--poki-blue);
        outline: none;
    }
`;

function getSelectedLanguage() {
    const searchParams = new URLSearchParams(window.location.search);
    const selectedLanguage = searchParams.get('iso_lang')?.toLowerCase() || '';

    if (!LANGUAGE_OPTIONS.some(({ value }) => value === selectedLanguage)) {
        return '';
    }

    return selectedLanguage;
}

export default function LanguageSelector() {
    const handleLanguageChange = (event) => {
        const language = event.target.value;
        const url = new URL(window.location.href);

        if (language) {
            url.searchParams.set('iso_lang', language);
        } else {
            url.searchParams.delete('iso_lang');
        }

        window.location.href = url.href;
    };

    return (
        <LanguageControl>
            Language
            <LanguageSelect
                aria-label="Game language"
                defaultValue={getSelectedLanguage()}
                onChange={handleLanguageChange}
            >
                {LANGUAGE_OPTIONS.map(({ value, label }) => (
                    <option key={value || 'browser'} value={value}>
                        {label}
                    </option>
                ))}
            </LanguageSelect>
        </LanguageControl>
    );
}
